/**
 * Componente NotificationToast
 * Muestra notificaciones temporales al usuario
 */

import React from 'react';

/**
 * Componente NotificationToast
 * @param {Object} props - Propiedades del componente
 * @param {string} props.type - Tipo de notificación ('success' | 'error')
 * @param {string} props.message - Mensaje a mostrar
 */
const NotificationToast = ({ type, message }) => {
  if (!message) return null;

  const bgColor = type === 'success' ? 'bg-green-500' : 'bg-red-500';
  
  return (
    <div className={`fixed top-4 right-4 z-50 ${bgColor} text-white px-6 py-3 rounded-lg shadow-lg`}>
      {message}
    </div>
  );
};

export default NotificationToast;
